module.exports = __webpack_public_path__ + "img/Preistraeger2020.6cb3476d.jpg";